import { render, staticRenderFns } from "./NavClient.vue?vue&type=template&id=0d008753&scoped=true&"
import script from "./NavClient.vue?vue&type=script&lang=js&"
export * from "./NavClient.vue?vue&type=script&lang=js&"
import style0 from "./NavClient.vue?vue&type=style&index=0&id=0d008753&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d008753",
  null
  
)

export default component.exports